import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { useFormContext } from "./Form";
import { withFormWrapper } from "./withFormWrapper";
import { DateTimeInput, FORMATS } from "./DateTimeInput";
import moment from "moment";
var Range;
(function (Range) {
    Range["Start"] = "start";
    Range["End"] = "end";
})(Range || (Range = {}));
const RawDateRangeInput = observer(({ name, onChange, disabled, label, uniqueId }) => {
    const { values, formDisabled, setIsDirty } = useFormContext();
    const [dates, setDates] = useState({
        start: values.get(`${name}.${Range.Start}`),
        end: values.get(`${name}.${Range.End}`),
    });
    const handleChange = React.useCallback((selected, range) => {
        const updatedDates = {
            ...dates,
            [range === Range.End ? "end" : "start"]: selected,
        };
        setDates(updatedDates);
        if (onChange) {
            onChange(updatedDates, values.get(`${name}`));
        }
        if (typeof selected === "string") {
            values.set(`${name}.${range}`, selected);
            setIsDirty(true);
            return;
        }
        setIsDirty(true);
        values.set(`${name}.${range}`, selected ? selected.format(FORMATS["date"]) : undefined);
    }, [setIsDirty, values, name, dates]);
    const getValidStartDate = (currentDate) => {
        if (dates.end) {
            return moment(currentDate).isBefore(dates.end);
        }
        return moment(currentDate).isBefore("3000-01-01");
    };
    const getValidEndDate = (currentDate) => {
        if (dates.start) {
            return moment(currentDate).isAfter(dates.start);
        }
        return moment(currentDate).isAfter("1900-01-01");
    };
    return (React.createElement("div", { className: "date-range" },
        React.createElement(DateTimeInput, { name: `${name}.${Range.Start}`, labelHidden: true, label: `${label ? `${label} ` : ""}Start`, onChange: (selected) => handleChange(selected, Range.Start), disabled: formDisabled || disabled, type: "date", isValidDate: getValidStartDate, placeholder: !dates.end ? "Start" : undefined, uniqueId: uniqueId && `start-${uniqueId}` }),
        React.createElement(DateTimeInput, { name: `${name}.${Range.End}`, labelHidden: true, label: `${label ? `${label} ` : ""}End`, onChange: (selected) => handleChange(selected, Range.End), disabled: formDisabled || disabled, type: "date", isValidDate: getValidEndDate, placeholder: !dates.end ? "End" : undefined, uniqueId: uniqueId && `end-${uniqueId}` })));
});
export const DateRangeInput = withFormWrapper({
    WrappedComponent: RawDateRangeInput,
    options: "group",
});
